import * as THREE from 'three';
import GameManager from '../components/GameManager';
import AssetsManager from '../components/AssetsManager';
import gsap from 'gsap';


import Tools from '../utils/Tools';
import { GameConfig } from '../utils/GameConfig';
import config from 'config';
import { Color } from 'three';
import { DEG_TO_RAD } from 'pixi.js';


export default class Ball extends THREE.Object3D {
    constructor(options) {
        super();

        this.beginBounceAnimation = this.beginBounceAnimation.bind(this);
        this.stopBounceAnimation = this.stopBounceAnimation.bind(this);

        this._ballInitialPosition = new THREE.Vector3(0, 0.24, -2);

        // Is the ball dropping
        this._isBallDropping = false;
        this._isBallBeenCalled = false;

        // Is the ball at the state of super fire
        this._isBallSuperFire = false;

        // The ball itself
        this._ball = null;

        // The color of the ball
        this._ballColor = null;

        // The trail of the ball
        this._trail = null;

        // The boost of the ball
        this._boostTrail = null;

        // The number of the boost trail instance
        this._boostTrailInstanceCount = 8;

        // The data array of boost trail
        this._boostTrailInstanceData = [];

        // The particle mesh of collision effect
        this._particleMesh = null;

        // Collection of particle meshes
        this._particleMeshesArray = [];

        // Big particle mesh
        this._bigParticleMesh = null;

        // The raycaster of the ball on the left
        this.raycasterLeft = new THREE.Raycaster();

        // The raycaster of the ball on the right
        this.raycasterRight = new THREE.Raycaster();

        this.timeAnim = 0.08;
    }


    /** 
     * Public 
    */

    build() {
        this._setupBall();        
        this._setupBallTrail();
        this._setupBoostSphere();
        this._setupBoostTrail();
        this._setupParticleEffect();
        //this._setupBallBounceParticleSystem();
        //this._setupBallTrailParticleSystem();

        gsap.delayedCall(.1, this.beginBounceAnimation);
        
    }

    update() {


        // Check if raycast is allowed
        if (config.losePlatformTouched) {
            return;
        }

        // When the ball in dropping or bumping on the platform
        if (this._ball.position.y < 0.72) {
            // Raycaste below 2 raycaster
            const intersects = this._raycast2Below();
            //console.log(intersects[0].distance);

            if (intersects && intersects.length == 0) {
                // Game over
                return;
            }

            if (this._isBallDropping) {
                this._trail.material.uniforms.uVelocity.value = GameManager.platforms._ballVelocity / 3.5;
                if (intersects && intersects[0].distance < 0.72) {
                    if (!this._isBallBeenCalled) {

                        console.log("detectCollision");

                        var result = GameManager.platforms.detectCollision(intersects[0]);

                        if (result != "error") {
                            //appeler pour arreter la chute livre
                            this.beginBounceAnimation();
                        }
                    }
                }
            }
            else if (!this._isBallDropping) {
                if (intersects && intersects[0].distance > GameConfig.platformOffset) {
                    if (!this._isBallBeenCalled) {
                        GameManager.platforms.goingDown(false);
                        console.log("going down");
                        this.stopBounceAnimation();
                    }
                }
                else {
                    if (!this._isBallBeenCalled) {
                        intersects && GameManager.platforms.detectCollision(intersects[0]);

                        this._isBallBeenCalled = true;
                    }
                }
            }





        }
        else {
            this._isBallBeenCalled = false;
        }

        this._shieldHallo.visible && (this._shieldHallo.position.y = this._ball.position.y);

    }

    _raycast2Below() {
        // Raycast 2 ray below, one left one right, return the close one as intersects
        var rayOriginCenter = this._ball.position;
        const rayOriginCenterY = 0.24;
        var rayOriginLeft = new THREE.Vector3(rayOriginCenter.x - 0.2, rayOriginCenterY, rayOriginCenter.z);
        var rayOriginRight = new THREE.Vector3(rayOriginCenter.x + 0.2, rayOriginCenterY, rayOriginCenter.z);
        var rayDirection = new THREE.Vector3(0, -1, 0);
        this.raycasterLeft.set(rayOriginLeft, rayDirection);
        this.raycasterRight.set(rayOriginRight, rayDirection);

        const intersectsLeft = this.raycasterLeft.intersectObject(GameManager.platforms._platformInstanceObject);
        const intersectsRight = this.raycasterRight.intersectObject(GameManager.platforms._platformInstanceObject);

        var intersects = null;

        if (intersectsLeft[0] && intersectsRight[0]) {

            if (Math.abs(intersectsLeft[0].distance - intersectsRight[0].distance) < 0.24) {
                const platformInstanceData = GameManager.platforms._platformPiecesData;
                const leftCollisionType = platformInstanceData[intersectsLeft[0].instanceId].type;
                const rightCollisionType = platformInstanceData[intersectsRight[0].instanceId].type;

                if (leftCollisionType == "losePlatform") {
                    intersects = intersectsLeft;
                }
                else if (rightCollisionType == "losePlatform") {
                    intersects = intersectsRight;
                }
                else {
                    intersects = intersectsLeft;
                }
            }
            else if (intersectsLeft[0].distance < intersectsRight[0].distance) {
                intersects = intersectsLeft;
            }
            else if (intersectsLeft[0].distance > intersectsRight[0].distance) {
                intersects = intersectsRight;
            }


        }

        // Center the intersect's position
        if (intersects == intersectsLeft) {
            intersects[0].point.x += 0.2;
        }
        else if (intersects == intersectsRight) {
            intersects[0].point.x -= 0.2;
        }

        return intersects;
    }

    beginBounceAnimation(isBigBounce = false) {
        console.log("beginBounceAnimation");
        if (config.losePlatformTouched) {
            return;
        }

        this._ball.position.copy(this._ballInitialPosition);
        this._ball.rotation.set(0, 0, 0);
        this._ball.scale.set(1, 1, 1);

        // Reset some parameters
        this._isBallDropping = false;
        this._isBallBeenCalled = true;

        // Begin the bounce animation
        this.bouncePosTween && this.bouncePosTween.kill();
        this.bouncePosTween = gsap.to(this._ball.position, {
            duration: GameConfig.movementCircleDuration,
            y: GameConfig.bounceYPos,
            ease: "power1.out",
            yoyo: true,
            //yoyoEase: true,
            repeat: -1,
        });

        this.bounceRotateTween && this.bounceRotateTween.kill();
        this.bounceRotateTween = gsap.to(this._ball.rotation, {
            z: 2 * Math.PI,
            duration: GameConfig.movementCircleDuration * 2,
            ease: "none",
            //yoyo: true,
            repeat: -1,
        });

        this._ball.scale.set(GameConfig.initialXScale, GameConfig.initialYScale, 1);

        this.bounceScaleYTween && this.bounceScaleYTween.kill();
        this.bounceScaleYTween = gsap.to(this._ball.scale, {
            duration: GameConfig.movementCircleDuration,
            y: 1,
            ease: "power1.out",
            yoyo: true,
            //yoyoEase: true,
            repeat: -1,
        });

        this.bounceScaleXTween && this.bounceScaleXTween.kill();
        this.bounceScaleXTween = gsap.to(this._ball.scale, {
            duration: GameConfig.movementCircleDuration,
            x: 1,
            delay: GameConfig.movementCircleDuration / 2,
            ease: "power1.out",
            yoyo: true,
            //yoyoEase: true,
            repeat: -1,
        });

        // Setup the trail
        this.trailTween && this.trailTween.kill();
        this.trailTween = gsap.fromTo(this._trail.material.uniforms.uVelocity,
            {
                value: -2,
            },
            {
                value: 2,
                duration: GameConfig.movementCircleDuration * 2,
                ease: "none",
                repeat: -1,
            });

        this.trailPosTween && this.trailPosTween.kill();
        this.trailPosTween = gsap.to(this._trail.position, {
            y: GameConfig.bounceYPos,
            duration: GameConfig.movementCircleDuration,
            ease: "power1.out",
            yoyo: true,
            //yoyoEase: true,
            repeat: -1,
        });


        // Setup the particle effect
        var indexOfParticleEffect = Tools.randomNum(0, 2);
        this._particleMesh = this._particleMeshesArray[indexOfParticleEffect];
        this._particleMesh.position.copy(this._ballInitialPosition);
        this._particleMesh.position.z = -3;

        this.particle1Tween && this.particle1Tween.kill();
        this.particle1Tween = gsap.fromTo(this._particleMesh.scale, { x: 0, y: 0, z: 0 },
            { x: 1.5, y: 2, z: 2, duration: GameConfig.movementCircleDuration * 2, ease: "power1", repeat: -1 });

        var originalParticlePosition = this._particleMesh.position;

        this.particle2Tween && this.particle2Tween.kill();
        this.particle2Tween = gsap.fromTo(this._particleMesh.position, { x: originalParticlePosition.x, y: originalParticlePosition.y, z: originalParticlePosition.z },
            { x: originalParticlePosition.x, y: originalParticlePosition.y - 3, z: originalParticlePosition.z - 1, duration: GameConfig.movementCircleDuration * 2, ease: "back.in(1.4)", repeat: -1 });

        this.particle3Tween && this.particle3Tween.kill();
        this.particle3Tween = gsap.fromTo(this._particleMesh.material, { opacity: 1 }, { opacity: 0, duration: GameConfig.movementCircleDuration * 2, ease: "power3.in", repeat: -1 });

        // Emit big particle effect
        // if (isBigBounce) {
        //     this.emitBigParticleEffect();
        // }
    }



    stopAnimation(callBack) {
        console.log("stopAniamtion");

        this.bouncePosTween.kill();
        this.bounceRotateTween.kill();
        this.particle1Tween.kill();
        this.particle2Tween.kill();
        this.particle3Tween.kill();
        this.trailPosTween.kill();
        this.trailTween.kill();
        this.bounceScaleXTween.kill();
        this.bounceScaleYTween.kill();

        for (let i = 0; i < this._particleMeshesArray.length; i++) {
            this._particleMeshesArray[i].scale.x = 0;
        }


        gsap.to(this._trail.material.uniforms.uVelocity, { duration: .2, value: 0 });
        gsap.to(this._ball.position, { duration: .5, y: .25, ease: "bounce.out" });
        gsap.to(this._ball.scale, {
            duration: .65, x: 1, y: 1, z: 1, ease: "elastic.out(1, 0.3)", onComplete: () => {
                callBack();
            }
        });
    }




    stopBounceAnimation() {

        console.log("stopBounceAnimation");

        this._isBallDropping = true;
        this._isBallBeenCalled = false;

        // Stop ball animation
        gsap.killTweensOf(this._ball.position);
        gsap.killTweensOf(this._ball.scale);
        gsap.killTweensOf(this._ball.rotation);

        // Stop trail animation
        gsap.killTweensOf(this._trail.material.uniforms.uVelocity);
        gsap.killTweensOf(this._trail.position);

        // Stop particle effect
        this._particleMesh.material.opacity = 0;
        gsap.killTweensOf(this._particleMesh.scale);
        gsap.killTweensOf(this._particleMesh.position);
        gsap.killTweensOf(this._particleMesh.material);

        //this._ball.position.copy(this._ballInitialPosition);
        gsap.to(this._ball.position, {
            x: this._ballInitialPosition.x,
            y: this._ballInitialPosition.y,
            z: this._ballInitialPosition.z,
            duration: this.timeAnim,
            ease: "power1.in",
        });
        this._ball.rotation.set(0, 0, 0);
        this._ball.scale.set(1, 1, 1);

        //this._trail.position.copy(this._ballInitialPosition);
        gsap.to(this._trail.position, {
            x: this._ballInitialPosition.x,
            y: this._ballInitialPosition.y,
            z: this._ballInitialPosition.z,
            duration: this.timeAnim,
            ease: "power1.in",
        });
        this._trail.material.uniforms.uVelocity.value = GameManager.platforms._ballVelocity / 3.5;
    }

    async changeSkin(skinName, skinBtn) {

        if (skinName === "") {

            while (this._ball.children.length) {
                this._ball.remove(this._ball.children[0]);
            }

            this._ball.material.transparent = true;
            this._ball.material.opacity = 1;

        } else {

            skinBtn && skinBtn.loadingSkin();

            let model = await AssetsManager.getModelByName(skinName);

            while (this._ball.children.length) {
                this._ball.remove(this._ball.children[0]);
            }
            this._ball.material.transparent = true;
            this._ball.material.opacity = 0;
            skinBtn && skinBtn.skinLoaded();

            if (model) {
                const skin = model.scene.clone();
                var skinDataConfigArray = [].concat(GameConfig.basicSkinList, GameConfig.rareSkinList, GameConfig.funkySkinList, GameConfig.epicSkinList, GameConfig.chestSkinList);
                const skinDataConfig = skinDataConfigArray.find(element => element.name === skinName);
                skin.scale.set(skinDataConfig.scale, skinDataConfig.scale, skinDataConfig.scale);
                this._ball.add(skin);
            }
        }
    }

    emitBigParticleEffect() {
        // Setup the big particle effect
        this._bigParticleMesh.position.copy(this._ballInitialPosition);
        this._bigParticleMesh.position.z = -3;

        gsap.fromTo(this._bigParticleMesh.scale, { x: 0, y: 0, z: 0 },
            { x: 1.5, y: 2, z: 2, duration: GameConfig.movementCircleDuration * 2, ease: "power1", repeat: -1 });

        var originalParticlePosition = this._bigParticleMesh.position;
        gsap.fromTo(this._bigParticleMesh.position, { x: originalParticlePosition.x, y: originalParticlePosition.y, z: originalParticlePosition.z },
            { x: originalParticlePosition.x, y: originalParticlePosition.y - 3, z: originalParticlePosition.z - 1, duration: GameConfig.movementCircleDuration * 2, ease: "back.in(1.4)" });

        gsap.fromTo(this._bigParticleMesh.material, { opacity: 1 }, { opacity: 0, duration: GameConfig.movementCircleDuration * 2, ease: "power3.in" });
    }

    _setupBall() {

        this._ballColor = GameManager.gameColors.ballColorNormal;

        let geometry = new THREE.SphereGeometry(0.24, 16, 16);
        let material = new THREE.MeshPhongMaterial({
            //side: THREE.DoubleSide,
            color: this._ballColor,
            //roughness: 0.8,
            transparent: true,
            opacity: 1,
            // depthWrite: false,
            // wireframe: true,
        });


        this._ball = new THREE.Mesh(geometry, material);
        this._ball.position.copy(this._ballInitialPosition);
        this._ball.scale.set(GameConfig.initialXScale, GameConfig.initialYScale, 1);
        this.add(this._ball);

        GameManager.EVENT_DISPATCHER.addEventListener("ballStatusChange", (event) => {
            this._updateBallStatus(event.data);
        });
    }

    _setupBallTrail() {

        let vertexShaderTrail = `varying vec2 vUv;
        uniform float uVelocity;
        void main() {
            vUv = uv;
            vec3 transformed = position.xyz;
            transformed.x *= 1.0 - uv.y + 0.1;
            transformed.y *= uVelocity;
            transformed.y += uVelocity / 2.;
            gl_Position = projectionMatrix* modelViewMatrix * vec4(transformed.xyz, 1.0);
        }
        `

        let fragmentShaderTrail = `uniform vec3 uColor;
        uniform float uVelocity;
        varying vec2 vUv;
        void main() {
            gl_FragColor = vec4(uColor, 1.0 - vUv.y - 0.2 );
        }`

        const uniforms = {
            uVelocity: { value: 0 },
            uColor: { value: new THREE.Color(this._ballColor) },
        };
        let geometry = new THREE.PlaneGeometry(0.20, 1);
        let material = new THREE.ShaderMaterial({
            side: THREE.DoubleSide,
            vertexShader: vertexShaderTrail,
            fragmentShader: fragmentShaderTrail,
            uniforms,
            transparent: true,
            depthWrite: true,

        });

        this._trail = new THREE.Mesh(geometry, material);
        this._trail.position.z = -2;
        this.add(this._trail);
    }

    _setupBoostSphere() {
        const geometry = new THREE.PlaneGeometry(2 * GameConfig.initialXScale, 2 * GameConfig.initialYScale);
        const material = new THREE.MeshBasicMaterial({ color: 0xff0000, side: THREE.DoubleSide, map: AssetsManager.texturesThree.BoostCircle, transparent: true, opacity: 0.8 });

        this._boostSphere = new THREE.Mesh(geometry, material);
        this._boostSphere.rotation.z += Math.PI / 2;
        this._boostSphere.position.copy(this._ballInitialPosition);
        this._boostSphere.scale.set(0, 0, 0);
        this.add(this._boostSphere);

        const shieldMaterial = new THREE.MeshBasicMaterial({ color: 0x3effff, side: THREE.DoubleSide, map: AssetsManager.texturesThree.shieldHallo, transparent: true });
        this._shieldHallo = new THREE.Mesh(geometry, shieldMaterial);
        this._shieldHallo.scale.set(0, 0, 0);
        this._shieldHallo.visible = false;
        this._shieldHallo.material.depthTest = false
        this._shieldHallo.rotation.x += DEG_TO_RAD * 45;
        this._shieldHallo.position.copy(this._ballInitialPosition);
        this.add(this._shieldHallo);

        //For test
        // this._updateBallStatus("shield");

    }



    _animateHallo(time = 1) {
        this._boostSphere.scale.set(1, 1, 1);
        this._boostSphere.material.opacity = 1;
        gsap.to(this._boostSphere.scale, { duration: time, x: 1.5, y: 1.5, z: 1.5 });
        gsap.to(this._boostSphere.material, {
            delay: time * .5, duration: time * 2, opacity: 0, onComplete: () => {
                this._animeHallo && this._animateHallo(time);
            }
        });
    }


    animateShield(val) {
        if (val) {
            this._shieldHallo.visible = true;
            this._shieldHallo.scale.set(0, 0, 0);
            gsap.to(this._shieldHallo.scale, { duration: .5, x: 1, y: 1, z: 1, ease: "back.out(1)" });
        } else {
            gsap.to(this._shieldHallo.scale, {
                duration: .25, x: 0, y: 0, z: 0, onComplete: () => {
                    this._shieldHallo.visible = false;
                }
            });

        }
    }


    wiggleShield(time, callBack) {

        let wiggleDuration = .1;
        let wiggleTime = time / wiggleDuration;

        for (let i = 0; i < wiggleTime; i++) {
            gsap.delayedCall(wiggleDuration * i, (id) => {

                this._shieldHallo.material.opacity = this._shieldHallo.material.opacity > .2 ? .2 : 1;

                // this._shieldHallo.visible = !this._shieldHallo.visible;

                if (id >= wiggleTime - 1) {
                    callBack && callBack();
                }
            }, [i]);
        }


    }



    _setupBoostTrail() {
        // Load the boost trail material
        const boostTrailMaterial = new THREE.MeshStandardMaterial({ opacity: 0.2, transparent: true, side: THREE.DoubleSide });

        // Load the boost trail geometry
        const boostTrailGeometry = new THREE.CylinderGeometry(0.65, 0.65, 0.2, 20, 1);


        // Construct the mesh info data
        for (let index = 0; index < this._boostTrailInstanceCount; index++) {
            let pieceData;
            pieceData = {
                position: new THREE.Vector3(0, 0, 0),
                rotation: new THREE.Vector3(0, 0, 0),
                scale: new THREE.Vector3(1, 1, 1),
            };

            this._boostTrailInstanceData.push(pieceData);
        }

        // Render the trail
        this._boostTrail = new THREE.InstancedMesh(boostTrailGeometry, boostTrailMaterial, this._boostTrailInstanceCount);
        this._boostTrail.receiveShadow = true;
        this._boostTrail.castShadow = true;
        this._boostTrail.name = "boostTrail";

        let dummy = new THREE.Object3D();

        for (let index = 0; index < this._boostTrailInstanceCount; index++) {
            const element = this._boostTrailInstanceData[index];

            dummy.position.copy(element.position);
            dummy.rotation.set(element.rotation.x, element.rotation.y, element.rotation.z);
            dummy.scale.copy(element.scale);
            dummy.updateMatrix();
            this._boostTrail.setMatrixAt(index, dummy.matrix);
        }

        // Adjust the position of the boost trail
        this._boostTrail.position.z = this._ballInitialPosition.z;
        this._boostTrail.position.y = 0;
        this._boostTrail.scale.set(1, 1, 1);

        this.add(this._boostTrail);

        // Hide the boost trail behind the tube
        this._boostTrail.position.z = -this._ballInitialPosition.z;

        // Add animation to the trail
        const animationDuration = 0.6;
        const animationDelay = animationDuration / this._boostTrailInstanceCount;

        for (let index = 0; index < this._boostTrailInstanceCount; index++) {
            let dummy = new THREE.Object3D();
            const indexOfInstance = index;

            dummy.position.set(this._boostTrailInstanceData[index].position.x, this._boostTrailInstanceData[index].position.y, this._boostTrailInstanceData[index].position.z);
            dummy.rotation.set(this._boostTrailInstanceData[index].rotation.x, this._boostTrailInstanceData[index].rotation.y, this._boostTrailInstanceData[index].rotation.z);
            dummy.scale.set(0, 0, 0);

            gsap.to(dummy.position, { y: 4, duration: animationDuration, delay: animationDelay * index, ease: "none", repeat: -1 });

            gsap.to(dummy.scale, {
                x: 1, y: 1, z: 1,
                duration: animationDuration, delay: animationDelay * index,
                ease: "none",
                repeat: -1,
                onUpdate: (indexOfInstance, dummy) => {
                    dummy.updateMatrix();
                    this._boostTrail.setMatrixAt(indexOfInstance, dummy.matrix);
                    this._boostTrail.instanceMatrix.needsUpdate = true;
                },
                onUpdateParams: [indexOfInstance, dummy],
            });
        }
    }

    _beginBoostTrail(colorOfBoostTrail) {
        //console.log("beginBoostTrail", colorOfBoostTrail);
        this._boostTrail.position.z = this._ballInitialPosition.z;

        // Change the color of the boost trail
        for (let index = 0; index < this._boostTrailInstanceCount; index++) {
            //console.log("index", index);
            this._boostTrail.setColorAt(index, colorOfBoostTrail);
            this._boostTrail.instanceColor.needsUpdate = true;
        }

    }

    _stopBoostTrail() {
        //console.log("stopBoostTrail");
        this._boostTrail.position.z = -this._ballInitialPosition.z;
    }

    _setupParticleEffect() {
        // Set up the 3 normal particle effect
        for (let index = 0; index < 3; index++) {
            const name = "ParticleEffect" + index;
            //console.log(name);

            var particleMaterial = new THREE.MeshPhongMaterial({ map: AssetsManager.texturesThree[name], transparent: true, depthWrite: false, side: THREE.DoubleSide });
            var particleGeometry = new THREE.PlaneGeometry(2, 2);

            this._particleMeshesArray[index] = new THREE.Mesh(particleGeometry, particleMaterial);

            this._particleMeshesArray[index].position.copy(this._ballInitialPosition);
            this._particleMeshesArray[index].position.z = -3;

            this._particleMeshesArray[index].material.opacity = 0;
            this._particleMeshesArray[index].material.color.set(GameManager.gameColors.ballColorNormal);

            this.add(this._particleMeshesArray[index]);
        }

        // Set up the big particle effect
        var bigParticleMaterial = new THREE.MeshPhongMaterial({ map: AssetsManager.texturesThree.ParticleEffect3, transparent: true, depthWrite: false, side: THREE.DoubleSide });
        var bigParticleGeometry = new THREE.PlaneGeometry(6, 2);

        this._bigParticleMesh = new THREE.Mesh(bigParticleGeometry, bigParticleMaterial);

        this._bigParticleMesh.position.copy(this._ballInitialPosition);
        this._bigParticleMesh.position.z = -3;

        this._bigParticleMesh.material.opacity = 0;
        this._bigParticleMesh.material.color.set(GameManager.gameColors.losePlatformColor);

        this.add(this._bigParticleMesh);
    }

    _updateBallStatus(ballStatus) {
        this._ballPos = GameManager.ball.position.y;
        let color;

        switch (ballStatus) {
            case 'normal':
                this.particlesBounceStartTime = -1;
                this._ballColor = GameManager.gameColors.ballColorNormal;
                color = new THREE.Color(this._ballColor);
                this._ball.material.color.set(color);
                this._trail.material.uniforms.uColor.value.set(color);
                this._animeHallo = false;
                // this._shieldHallo.material.opacity = 1;
                gsap.to(this._shieldHallo.scale, { duration: .5, x: 1, y: 1, z: 1, ease: "power4.out" });
                this._boostSphere.material.color = new Color(0xff0000);
                gsap.to(this._boostSphere.scale, { x: 0, y: 0, z: 0, repeat: 0, duration: 0.2, ease: "back" });
                this._isBallSuperFire = false;
                this._stopBoostTrail();
                break;
            case 'fire':
                this._ballColor = GameManager.gameColors.ballColorNormal;
                color = new THREE.Color(this._ballColor);
                this._ball.material.color.set(color);
                this._trail.material.uniforms.uColor.value.set(color);
                this._isBallSuperFire = true;
                // this._shieldHallo.material.opacity = 0;
                gsap.to(this._shieldHallo.scale, { duration: .5, x: 0, y: 0, z: 0, ease: "power4.in" });
                this._beginBoostTrail(color);
                break;
            case 'superFire':
                this._ballColor = GameManager.gameColors.ballColorFire;
                color = new THREE.Color(this._ballColor);
                this._ball.material.color.set(color);
                this._trail.material.uniforms.uColor.value.set(color);
                // gsap.fromTo(this._boostSphere.scale, { x: 1, y: 1, z: 1, duration: 0.05 }, { x: 0.9, y: 0.9, z: 0.9, yoyo: true, duration: 0.05 });
                // this._shieldHallo.material.opacity = 0;
                gsap.to(this._shieldHallo.scale, { duration: .5, x: 0, y: 0, z: 0, ease: "power4.in" });
                this._animeHallo = true;
                this._animateHallo(.25);
                this._beginBoostTrail(color);
                break;
            // case 'shield':
            //     // this._shieldHallo.material.opacity = 1;
            //     this.animateShield(true);
            //     break;
            default:
                break;
        }
    }


    updateColor() {

        this._ball.material.color.set(GameManager.gameColors.ballColorNormal);
        this._trail.material.uniforms.uColor.value.set(GameManager.gameColors.ballColorNormal);
        for (let index = 0; index < 3; index++) {
            this._particleMeshesArray[index].material.color.set(GameManager.gameColors.ballColorNormal);
        }
        this._bigParticleMesh.material.color.set(GameManager.gameColors.losePlatformColor);

    }

}